export class AggregatedRoles {
    static readonly Authenticated = "Authenticated";
    static readonly Anyone = "Anyone";
}